<template>
    <div>
        <Card v-if="storeCount === 0">
            <div class="text-center">
                <div style="font-size: 3.6em;">
                    <i class="fas fa-building"></i>
                </div>
                <div class="h2">
                    <p class="pt-4 pb-2" v-html="__('dashboard.no_stores')"></p>
                    <p>
                        <a :href="$route('stores.create')"
                           class="mt-4 btn btn-sm btn-light-primary">{{ __('store.create_new_store') }}</a>
                    </p>
                </div>
            </div>
        </Card>
        <Card v-else>
            <h3>Externe Anbindung</h3>
            <div class="mt-7">
                <p>Verbinden Sie Ihr youbuyda Konto mit externen Anbietern und Partnern</p>
                <div v-if="providers.includes('bliggit')">
                    <bliggit :stores="stores" :existingAccounts="existingAccounts"></bliggit>
                </div>
            </div>
        </Card>
    </div>
</template>

<script>
import Bliggit from '@components/StoreSettings/Bliggit'
import Card from '@components/Cards/Card.vue'

export default {
    components: {
        Card,
        Bliggit,
    },
    props: {
        storeCount: Number,
        existingAccounts: [Object, Array],
        providers: Array,
        stores: Array,
    },
};
</script>
